<template>
  <v-row align="center" justify="center">
    <v-col cols="12" justify="center" align="center">
      <v-img
        class="bg"
        :src="require('@/assets/imgs/' + imgNmae)"
        max-height="470"
       
      >
       <!-- gradient="to left,  rgba(0, 0, 0, 0.5) ,rgba(0, 0, 0, .01) 40%" -->
         <v-row justify="end" align="center" style="height: 100%"> 
            <v-col cols="6" ></v-col>
          <v-col cols="6"   align="start">
            <div class="header  "  :class="!$vuetify.breakpoint.smAndDown ? 'px-16' : 'mt-n16'">
              <!-- <span >{{JSON.parse(this.$store.state.SiteData.find((member)=>member.Name=='home').Content).header}}</span> -->
              <span >Trusted Leaders in Technology Solutions</span>
            </div>
            
            <v-btn
            rounded
            elevation="0"
            :style="[!$vuetify.breakpoint.smAndDown ? {'margin-left':'280px !important'}:{}]"
              class=" contact-us-btn " :class="!$vuetify.breakpoint.mdAndDown ? 'ml-16 mt-10' : 'mt-4'"
             
              >Contact us today</v-btn
            >
          </v-col>
        </v-row>
      </v-img>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      imgNmae: "Website Header 1.png",
    };
  },
};
</script>

<style lang="scss" scoped>
 @media only screen and (max-width: 1150px) {
  .header span {
    font-size: 20px !important;
  }
  .contact-us-btn {
    font-size: 12px !important;
     height: 25px  !important;
  }
}
@media only screen and (max-width: 600px) {
  .header span {
    font-size: 16px !important;
  }
  .contact-us-btn {
    height: 20px  !important;
    font-size: 10px !important;
    
  }
}



.header {
 
 span {
    letter-spacing: 2px;
    font-size: 36px;
    font-weight: 700;
    font-family: Raleway;
    color: white;
  }
  

}
</style>